import { reducer } from 'redux-form/immutable';

import * as resourceConstants from '../Resources/View/constants';

export default reducer.plugin({
  [resourceConstants.RESOURCE_EVENTS_FORM]: (state, action) => {
    switch (action.type) {
      default: {
        return state;
      }
    }
  },
});

